import { render, staticRenderFns } from "./RichTextField.vue?vue&type=template&id=927d1c1c&scoped=true"
import script from "./RichTextField.vue?vue&type=script&lang=js"
export * from "./RichTextField.vue?vue&type=script&lang=js"
import style0 from "./RichTextField.vue?vue&type=style&index=0&id=927d1c1c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927d1c1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('927d1c1c')) {
      api.createRecord('927d1c1c', component.options)
    } else {
      api.reload('927d1c1c', component.options)
    }
    module.hot.accept("./RichTextField.vue?vue&type=template&id=927d1c1c&scoped=true", function () {
      api.rerender('927d1c1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/personalization/fields/RichTextField.vue"
export default component.exports